import React, { useState, useEffect, useContext } from 'react';
import queryString from 'query-string';
import RedirectContext from '../../../contexts/RedirectContext';
import UserContext from '../../../contexts/UserContext';
import { linkAlexaUsingInviteCode } from '../../../services/sso';

import { getResidentInvitationByToken } from '../../../services/messageRecipients';
import { getMyQuota } from '../../../services/quotas';

import { toast } from 'react-toastify';

const AlexaInviteSSORedirect = (props) => {
    const toggleRedirect = useContext(RedirectContext);
    const [message, setMessage] = useState('');

    const handleSSODone = (invitedUserPays, paymentManagerId, invitationToken) => {
        if (!invitedUserPays) {
            return handleDone();
        }

        toast.success('Alexa Linked Successfully!', {
            position: 'bottom-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
        });

        setMessage('Redirecting you to payment');
        toggleRedirect(`/public/checkout/${paymentManagerId}?invitationId=${invitationToken}`);
    };

    const handleDone = (invitationToken) => {
        toast.success('Alexa Linked Successfully!', {
            position: 'bottom-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
        });
        setMessage('Done!');

        toggleRedirect(`/public/checkout-success`);
    };
    useEffect(() => {
        const { code, state } = queryString.parse(props.location.search);
        const user = JSON.parse(localStorage.getItem(atob(state)));

        const hostname = window.location.hostname;
        const redirect_uri = `https://${hostname}/sso-redirect`;

        try {
            linkAlexaUsingInviteCode(user.invitationToken, code, redirect_uri)
                .then(async () => {
                    const invitation = await getResidentInvitationByToken(user.invitationToken);

                    if (invitation.invitedUserPays && invitation.paymentManagerId) {
                        const response = await getMyQuota(invitation.paymentManagerId);

                        if (response.totalQuota >= response.residentCount) {
                            return handleDone(user.invitationToken);
                        } else {
                            return handleSSODone(
                                invitation.invitedUserPays,
                                invitation.paymentManagerId,
                                user.invitationToken,
                            );
                        }
                    } else {
                        return handleDone(user.invitationToken);
                    }
                })
                .catch((err) => {
                    toast.error('Account linking Failed', {
                        position: 'bottom-center',
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                    });
                });
        } catch (err) {
            toast.error('Account linking Failed', {
                position: 'bottom-center',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
            });
        }
    }, [props.location.search]);

    return (
        <>
            <div className="alexa-invite-link-sso">
                {message ? <div className="done">{message}</div> : <div className="loading">Enabling Alexa</div>}
            </div>
        </>
    );
};

export default AlexaInviteSSORedirect;
